import { Component, input, OnInit, inject, computed } from "@angular/core";
import {
  Notification,
  NotificationService,
} from "../../services/notification.service";
import { MessageModule } from "@cq/app/shared/message/message.module";
import { map, startWith, timer } from "rxjs";
import { IconModule } from "@cq/app/shared/icon/icon.module";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { CommonModule } from "@angular/common";
import { MatButtonModule } from "@angular/material/button";

const POLL_INCREMENT = 100;

@Component({
  selector: "cq-notification",
  imports: [
    CommonModule,
    IconModule,
    MessageModule,
    MatButtonModule,
    MatProgressSpinnerModule,
  ],
  templateUrl: "./notification.component.html",
  styleUrl: "./notification.component.scss",
  host: {
    "[class.level-error]": "isError()",
    "[class.level-info]": "isInfo()",
    "[class.level-warning]": "isWarning()",
  },
})
export class NotificationComponent implements OnInit {
  notification = input.required<Notification>();
  isError = computed(() => this.notification().level === "error");
  isInfo = computed(() => this.notification().level === "info");
  isWarning = computed(() => this.notification().level === "warning");
  message = computed(() => this.notification().message);

  elapsed = timer(0, POLL_INCREMENT).pipe(
    map((count) => {
      const notification = this.notification();
      const time = count * POLL_INCREMENT;
      const elapsed = (time / notification.duration) * 100;
      const remaining = 100 - elapsed;
      return Math.max(remaining, 0);
    }),
    startWith(100),
  );

  private readonly service = inject(NotificationService);

  ngOnInit(): void {
    const notification = this.notification();
    timer(notification.duration).subscribe(() =>
      this.service.clear(this.notification()),
    );
  }

  dismiss() {
    this.service.clear(this.notification());
  }
}
